<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="titlepage">
<h4 class="author">Ellen Key</h4>
<h2 class="title" id="sigil_toc_id_1">Über Liebe und Ehe</h2>
<p class="center"><br class="chapter"/></p>
<p class="center">*</p>
<div class="dedication">
<p class="calibre1">Der Erinnerung an die Toten,<br class="calibre2"/>
      die mir in Liebe das Leben gaben<br class="calibre2"/>
      und der Hoffnung auf die Jugend,<br class="calibre2"/>
      die mit neuer Frömmigkeit<br class="calibre2"/>
      des Lebens Gabe hüten will.</p>
</div>
<p class="center">*</p>
</div>
<div class="chapter" id="calibre_pb_2"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// liebeehe_split_000.vue?6f19d403